import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';

class MenuMobile extends Component {
    render() {
        return (
            <SideBar
            menuItems={this.props.menuItems} 
            openMenuItem={this.props.openMenuItem}
            toggleMenuMobile={this.props.toggleMenuMobile}
            />
        )
    }
}

export default MenuMobile;